import React from 'react';

import {
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import DataTable from 'examples/Tables/DataTable';
import ConfirmModal from '../../../components/ConfirmModal/ConfirmModal';

import useUsersHook from '../../../hooks/useUsersHook';
import {
  userStatusList,
  investmentStatusList,
  regulationStatusList,
} from '../../../constants/user.constants';
import DownloadMenu from 'components/DownloadMenu/DownloadMenu';

const MenuProps = {
  PaperProps: {
    style: {
      width: 250,
    },
  },
};

const USUsers = () => {
  const {
    columns,
    rows,
    totalCount,
    totalPage,
    isLoading,
    perPage,
    setPerPage,
    currentPage,
    setCurrentPage,
    setSortBy,
    sortBy,
    userKYCStatus,
    setUserKYCStatus,
    handleUserKYCStatus,
    userInvestmentStatus,
    setUserInvestmentStatus,
    handleUserInvestmentStatus,
    handleRegulationStatus,
    regulationStatus,
    setRegulationStatus,
    isFreezeModal,
    selectedUser,
    onCloseModal,
    onFreezeUserClick,
    searchTerm,
    setSearchTerm,
    onDownloadCSV,
    onDownloadXLSX,
    isFreezeLoading,
  } = useUsersHook({
    usersFrom: 'us',
  });

  const onDownloadCSVClick = () => {
    try {
      onDownloadCSV();
    } catch (error) {
      console.log({ error });
    }
  };

  const onDownloadXLSXClick = () => {
    try {
      onDownloadXLSX();
    } catch (error) {
      console.log({ error });
    }
  }

  return (
    <>
      <MDBox
        mx={2}
        py={3}
        px={2}
        variant="gradient"
        bgColor="info"
        borderRadius="lg"
        coloredShadow="info"
      >
        <MDTypography variant="h6" color="white">
          US Users
        </MDTypography>
      </MDBox>
      <Grid container spacing={4} p={3}>
        <Grid item xs={12} md={6} lg={4} xl={3}>
          <FormControl sx={{ minHeight: 48 }} fullWidth>
            <InputLabel id="user-status-label">KYC Approved</InputLabel>
            <Select
              labelId="user-status-label"
              id="user-status"
              value={userKYCStatus}
              onChange={handleUserKYCStatus}
              sx={{ minHeight: 48 }}
              input={<OutlinedInput label="User Status" />}
              MenuProps={MenuProps}
              endAdornment={
                <IconButton
                  sx={{
                    visibility: userKYCStatus ? 'visible' : 'hidden',
                    position: 'absolute',
                    right: '25px',
                    marginRight: '0',
                  }}
                  style={{
                    backgroundColor: 'white',
                  }}
                  onClick={() => {
                    setUserKYCStatus('');
                  }}
                  size="small"
                >
                  <ClearIcon />
                </IconButton>
              }
            >
              {userStatusList.map((status) => (
                <MenuItem value={status.value} key={status.value}>
                  {status.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6} lg={4} xl={3}>
          <FormControl sx={{ minHeight: 48 }} fullWidth>
            <InputLabel id="investment-status-label">
              Investment Status
            </InputLabel>
            <Select
              labelId="investment-status-label"
              id="investment-status"
              value={userInvestmentStatus}
              onChange={handleUserInvestmentStatus}
              sx={{ minHeight: 48 }}
              input={<OutlinedInput label="Investment Status" />}
              MenuProps={MenuProps}
              endAdornment={
                <IconButton
                  sx={{
                    visibility: userInvestmentStatus ? 'visible' : 'hidden',
                    position: 'absolute',
                    right: '25px',
                    marginRight: '0',
                  }}
                  style={{
                    backgroundColor: 'white',
                  }}
                  onClick={() => {
                    setUserInvestmentStatus('');
                  }}
                  size="small"
                >
                  <ClearIcon />
                </IconButton>
              }
            >
              {investmentStatusList.map((status) => (
                <MenuItem value={status.value} key={status.value}>
                  {status.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6} lg={4} xl={3}>
          <FormControl sx={{ minHeight: 48 }} fullWidth>
            <InputLabel id="regulation-status">
              Regulation D Status
            </InputLabel>
            <Select
              labelId="regulation-status"
              id="regulation-status"
              value={regulationStatus}
              onChange={handleRegulationStatus}
              sx={{ minHeight: 48 }}
              input={<OutlinedInput label="RegulationD Status" />}
              MenuProps={MenuProps}
              endAdornment={
                <IconButton
                  sx={{
                    visibility: regulationStatus ? 'visible' : 'hidden',
                    position: 'absolute',
                    right: '25px',
                    marginRight: '0',
                  }}
                  style={{
                    backgroundColor: 'white',
                  }}
                  onClick={() => {
                    setRegulationStatus('');
                  }}
                  size="small"
                >
                  <ClearIcon />
                </IconButton>
              }
            >
              {regulationStatusList.map((status) => (
                <MenuItem value={status.value} key={status.value}>
                  {status.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

        </Grid>
        <Grid item xs={12} md={6} lg={4} xl={3}>
          <FormControl sx={{ minHeight: 48, width: 'auto' }} >
            <DownloadMenu
              onDownloadCSVClick={onDownloadCSVClick}
              onDownloadXLSXClick={onDownloadXLSXClick}
            />
          </FormControl>
        </Grid>
      </Grid>
      <MDBox
        sx={{
          position: 'relative',
          paddingTop: '85px',
          paddingBottom: {
            xs: '150px',
            sm: '95px',
          },
        }}
      >
        <DataTable
          table={{ columns, rows }}
          isSorted={true}
          entriesPerPage={{ defaultValue: perPage }}
          showTotalEntries
          canSearch
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          perPage={perPage}
          setPerPage={setPerPage}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPage={totalPage}
          totalRecords={totalCount}
          hiddenColumns={['id']}
          queryPageSortBy={[sortBy]}
          setSortBy={setSortBy}
          isLoading={isLoading}
          onRowClick={(userId) => {
            window.open(`/users/${userId}`, '_self',);
          }}
          isRowClickable
        />
      </MDBox>
      {isFreezeModal && (
        <ConfirmModal
          open={isFreezeModal}
          onOkayClick={onFreezeUserClick}
          onCloseModal={onCloseModal}
          modalText={`Are you sure you want to ${selectedUser?.isFreeze ? 'unfreeze' : 'freeze'
            } this user?`}
          okayText={`Yes, ${selectedUser?.isFreeze ? 'Unfreeze' : 'Freeze'}`}
          cancelText="No, cancel"
          isLoading={isFreezeLoading}
        />
      )}
    </>
  );
};

export default USUsers;
